export default __webpack_public_path__ + "static/media/item_4@2x.61b83919.webp";